import CandidateFileButtons from "#candidate/components/candidate-file/CandidateFileButtons"
import { CandidateFileFormDialog } from "#candidate/components/candidate-file/CandidateFileForm"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdFileGet } from "#candidate/services/api"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box, Button } from "@mui/material"
import { useMemo, useState } from "react"

export default function CandidateFile({ autoFetch }) {
	const [open, setOpen] = useState(false)
	const { candidateId, reloadFile: reload, candidate } = useCandidateRedux()
	const params = useMemo(() => ({ id: candidateId }), [candidateId])
	const { data, loading, error } = useApi(candidateIdFileGet, {
		params,
		autoFetch,
		reload,
	})
	const is_edit = candidate.is_enabled && candidate.vacancy_active

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />
	const options = {}
	if (candidate && candidate.is_enabled)
		options.customToolbar = () =>
			is_edit && (
				<Button variant="contained" color="primary" onClick={() => setOpen(true)}>
					Agregar Archivo
				</Button>
			)

	return (
		<Box
			sx={{
				display: "flex",
				flexWrap: "wrap",
				gap: 2,
				padding: 2,
			}}
		>
			<TableMain
				data={data?.data || []}
				items={[
					{ name: "name", label: "Nombre" },
					{ name: "created_at", label: "Creado el" },
					{ name: "created_by_name", label: "Creado por" },
					{
						name: "",
						label: " ",
						options: {
							customBodyRender: (value, datum) => <CandidateFileButtons data={datum} />,
						},
					},
				]}
				{...{ options }}
			/>
			<CandidateFileFormDialog {...{ open, setOpen }} />
		</Box>
	)
}
